export const downPropertyKey = {
  ASSET_NAME: 'name',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  ASSET_MOBILE: 'mobile',
  ASSET_EMAIL: 'email',
  FLOOR_SPACE: 'floorSpace',
  PROPERTY_TYPE: 'propertyType',
  RENTED_FROM: 'rentedFrom',
  RENTED_TO: 'rentedTo',
  TOTAL_EMISSION: 'totalEmissions',
  TOTAL_EMISSION_VEHICLE: 'totalEmissions',
  VEHICLE_TYPE: 'vehicleType',
  FUEL_USED: 'fuelUsed',
  FUEL_QUANTITY: 'fuelQuantity',
  COST: 'cost',
  PURCHASED: 'purchased',
  STATUS: 'status',
  COMMENT: 'comment'
};
export const downPropertyLabel = {
  ASSET_NAME: 'Asset Lessee Name',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  ASSET_MOBILE: 'Asset Mobile Number',
  ASSET_EMAIL: 'Asset Email ID',
  FLOOR_SPACE: 'Floor Space',
  PROPERTY_TYPE: 'Property Type',
  RENTED_FROM: 'Rented From',
  RENTED_TO: 'Rented To',
  TOTAL_EMISSION: 'Total Emissions',
  VEHICLE_TYPE: 'Vehicle Type',
  FUEL_USED: 'Fuel Used',
  FUEL_QUANTITY: 'Fuel Quantity',
  COST: 'Cost',
  PURCHASED: 'Purchased',
  STATUS_COMMENTS: 'Status & Comments',
  STATUS: 'Status',
  COMMENT: 'Comment'
};
